<template>
<div class="navbar">
    <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container" />

    <breadcrumb class="breadcrumb-container" />
    <p style="float:left; fontFamily: STXingkai,STXingkai,FangSong; color:#409EFF; fontSize: 20px; margin:15px 0 0 2%;" title="以客户为中心 以奋斗者为本 长期坚持提高运营效率">以客户为中心&nbsp;&nbsp;以奋斗者为本&nbsp;&nbsp;长期坚持提高运营效率</p>

    <div class="right-menu">
        <div class="right-menu-item-btn hover-effect " @click="goSeatPlan()">公司座位平面图</div>
        <div class="right-menu-item-btn hover-effect " @click="download()">操作手册</div>
        <div class="right-menu-item-btn hover-effect " @click="goSecretary()">如有问题，请联系秘书哦！(●'◡'●)</div>
        <template v-if="device!=='mobile'">
            <error-log class="errLog-container right-menu-item hover-effect" />

            <screenfull class="right-menu-item hover-effect" />

            <lang-select class="right-menu-item hover-effect" />
        </template>

        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
            <div>
                <svg-icon icon-class="right-upper-user" />
                {{ language==='zh'?name:nameEn }}
                <i class="el-icon-arrow-down" />
            </div>
            <el-dropdown-menu slot="dropdown">
                <router-link to="/">
                    <el-dropdown-item>{{ $t('navbar.index') }}</el-dropdown-item>
                </router-link>
                <el-dropdown-item divided>
                    <span style="display:block;" @click="logout">{{ $t('navbar.logOut') }}</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
    <!-- <el-dialog :visible.sync="showTip" title="提示"></el-dialog> -->
    <!-- <el-table :data="list" :border="false" size="mini">
      <el-table-column label="进行中会议">
        <el-table-column prop="id"></el-table-column>
        <el-table-column prop="subject"></el-table-column>
      </el-table-column>
      <el-table-column label="预计结束时间" prop="endTime"></el-table-column>
    </el-table> -->
    <div class="popTab" v-show="$store.getters.showTip">
        <div class="clearfix">
            <p style="float:left;margin:0; fontSize:24px; color:#E6A23C; width:100%">
                <i class="el-icon-warning" style="float:left"></i>
                <span style="float:left; fontSize:16px; color:#444; margin-left:10px;lineHeight:24px; fontWeight:bold">提示</span>
                <span style="float:right; fontSize:28px; color:#ccc; cursor:pointer" @click="closeTip">×</span>
            </p>
        </div>
        <div class="contentMsg">
            <p>进行中的会议：</p>
            <ul class="list clearfix">
                <li class="clearfix" v-for="(item,index) in meetingList" :key="index">
                    <strong class="strong" :title="'会议编号：'+item.id">【{{item.id}}】</strong>
                    <span class="title" :title="item.meeting_subject" @click="goDetails(item.id, item.meeting_type_id)">{{item.meeting_subject}}</span>
                    <span class="timeTip">{{item.estimate_end_time.split(' ')[1]}}</span>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import LangSelect from '@/components/LangSelect'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    LangSelect
  },
  data() {
    return {
      drawer: false,
      list: [{
        subject: '大会咖啡壶',
        id: 2232,
        endTime: '12:00:00'
      },
      {
        subject: '大会咖啡壶',
        id: 2232,
        endTime: '11:45:00'
      }
      ]
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'nameEn', 'avatar', 'device', 'language', 'showTip', 'meetingList'])
  },
  created() {},
  watch: {
    // 'showTip': function(val){
    //   const _this = this
    //   if(val){
    //     console.log(this.$store.getters.meetingList)
    //     let text = ''
    //     this.$store.getters.meetingList.forEach(item => {
    //       text += '<div class="clearfix"><strong class="strong">【'+item.id+'】</strong><span class="title" title="'+item.meeting_subject+'">'+item.meeting_subject+'</span><span class="timeTip">'+item.estimate_end_time.split(' ')[1]+'</span></div>'
    //     })

    //     let cl= this.$notify.warning({
    //       title:'提示',
    //       dangerouslyUseHTMLString: true,
    //       message: '<p>进行中的会议：</p>'+text,
    //       duration: 0,
    //       offset: 40,
    //       customClass:'notify',
    //       onClose: function(){
    //         _this.timeout()
    //       }
    //     })
    //   }else{

    //   }
    // }
  },
  methods: {
    closeTip() {
      this.$store.dispatch('closeTip')
      setTimeout(() => {
        this.$store.dispatch('getMeetingRun')
      }, 900000)
    },
    goDetails(id, type) {
      // 大杂会和早晚会区分
      if (type === 7) {
        this.$router.push({
          name: 'morningDetails',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({
          name: 'seeDetails',
          query: {
            id: id
          }
        })
      }
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      window.close()
    },
    goSeatPlan() {
      this.$router.push({
        name: 'seatManage'
      })
    },
    download() {
      window.open(location.origin + '/static/doc/sfc-metting.pdf')
    },
    goSecretary() {
      if (window.location.href.indexOf('secretaryList/index') !== -1) {

      } else {
        this.$router.replace('/secretaryList/index')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.newFuntion {
    display: inline-block;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;
    cursor: pointer;
    margin-right: 5px;
    margin-left: 8px;

    &:hover {
        background: rgba(0, 0, 0, 0.025);
    }
}

.navbar {
    height: 50px;
    overflow: hidden;

    .hamburger-container {
        line-height: 46px;
        height: 100%;
        float: left;
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
            background: rgba(0, 0, 0, 0.025);
        }
    }

    .breadcrumb-container {
        float: left;
    }

    .errLog-container {
        display: inline-block;
        vertical-align: top;
    }

    .right-menu {
        float: right;
        height: 100%;
        line-height: 50px;

        &:focus {
            outline: none;
        }

        .right-menu-item {
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 18px;
            color: #5a5e66;
            vertical-align: text-bottom;

            &.hover-effect {
                cursor: pointer;
                transition: background 0.3s;

                &:hover {
                    background: rgba(0, 0, 0, 0.025);
                }
            }
        }

        .right-menu-item-btn {
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 14px;
            color: #6d9eeb;
            vertical-align: text-bottom;
            text-shadow: 5px 5px 20px;

            &.hover-effect {
                cursor: pointer;
                transition: color 0.3s;

                &:hover {
                    color: rgb(27, 122, 218);
                }
            }
        }

        .avatar-container {
            margin-right: 30px;

            .avatar-wrapper {
                margin-top: 5px;
                position: relative;

                .user-avatar {
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                }

                .el-icon-caret-bottom {
                    cursor: pointer;
                    position: absolute;
                    right: -20px;
                    top: 25px;
                    font-size: 12px;
                }
            }
        }
    }
}
</style><style lang="scss">
.notify {
    width: 400px !important;
}

.popTab {
    width: 500px;
    min-height: 100px;
    position: fixed;
    right: calc(50% - 250px);
    top: 10px;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    padding: 14px;
    border-radius: 8px;
    border: 1px solid #EBEEF5;
    z-index: 99999
}

.contentMsg {
    width: 100%;
    margin: 0;
    padding: 0 20px;
    font-size: 14px;
    color: #606266;

    p {
        margin: 0 0 8px 0;
    }

    .list {
        padding-left: 0;
        margin: 0;

        li {
            list-style: none;
            height: 24px;
            line-height: 24px;

            .strong {
                float: left;
                width: 66px;
                // margin-right:5px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .title {
                float: left;
                width: 305px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: pointer;

                &:hover {
                    color: #6d9eeb;
                    // text-decoration: underline;
                }
            }

            .timeTip {
                float: right
            }
        }
    }
}
</style>
